<template>
  <div id="app">
    <Header></Header>

    <Page>
      <div class="pb-8 px-content">
        <div class="flex justify-center">
          <h1 class="headline">Impressum</h1>
        </div>

        <h2 class="mt-6 font-bold">Angaben gemäß § 5 Telemediengesetz:</h2>
        <p>
          Schlosserei Raichle GmbH & Co. KG
          <br />Kelterstraße 47
          <br />73265 Dettingen unter Teck
          <br />Deutschland
          <br />Telefon 07021 / 81516
          <br />E-Mail: info@schlosserei-raichle.de
          <br />
          <br />
          <b>Sitz der Gesellschaft</b>
          <br />Dettingen unter Teck, Deutschland
          <br />Amtsgericht Stuttgart HRA 733175
          <br />
          <br />
          <b>Persönlich haftende Gesellschafterin</b>
          <br />Raichle GmbH
          <br />Sitz der Gesellschaft Dettingen unter Teck
          <br />Amtsgericht Stuttgart HRB 760191
          <br />
          <br />
          <b>Geschäftsführer</b>
          <br />Christian Raichle
          <br />
          <br />
          <b>Umsatz­steu­er­iden­ti­fi­ka­ti­ons­nummer</b>
          <br />Ust-IdNr.: DE311399046
          <br />
        </p>
      </div>

      <CallToAction></CallToAction>
    </Page>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import CallToAction from "../components/CallToAction.vue";
import Page from "../components/Page.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page
  },
  data() {
    return {};
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/" + pic);
    }
  }
};
</script>

<style src="../assets/css/comfortaa.css"></style>
<style src="../assets/css/styles.css"></style>